import type { ComponentProps } from 'react';
import { cn } from '../../lib/cn.ts';

/**
 * A group on the page. Inside the white sheet a group is set off by a hairline
 * and a little tint, not a floating shadow: the sheet is already the surface.
 */
export function Card({ className, ...props }: ComponentProps<'section'>) {
  return <section className={cn('rounded-[1.25rem] bg-surface shadow-[inset_0_0_0_1px_var(--line)]', className)} {...props} />;
}

export function CardHeader({ className, ...props }: ComponentProps<'div'>) {
  return <div className={cn('flex flex-col gap-1.5 px-6 pt-6 pb-3 sm:px-7', className)} {...props} />;
}

export function CardTitle({ className, ...props }: ComponentProps<'h2'>) {
  return <h2 className={cn('font-display text-xl font-semibold leading-tight text-ink', className)} {...props} />;
}

export function CardDescription({ className, ...props }: ComponentProps<'p'>) {
  return <p className={cn('max-w-[62ch] text-[0.92rem] text-muted', className)} {...props} />;
}

export function CardContent({ className, ...props }: ComponentProps<'div'>) {
  return <div className={cn('px-6 pt-2 pb-6 sm:px-7', className)} {...props} />;
}

export function CardFooter({ className, ...props }: ComponentProps<'div'>) {
  return <div className={cn('flex items-center gap-2 px-6 pb-6 sm:px-7', className)} {...props} />;
}

/** Rows in a group, divided by hairlines. */
export function RowList({ className, ...props }: ComponentProps<'ul'>) {
  return (
    <ul
      className={cn('divide-y divide-line overflow-hidden rounded-[1.25rem] bg-surface shadow-[inset_0_0_0_1px_var(--line)]', className)}
      {...props}
    />
  );
}
